import { render } from "./eduForm.vue?vue&type=template&id=6f876f61&scoped=true"
import script from "./eduForm.vue?vue&type=script&lang=js"
export * from "./eduForm.vue?vue&type=script&lang=js"

import "./eduForm.vue?vue&type=style&index=0&id=6f876f61&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f876f61"]])

export default __exports__